<template lang="pug">
div
  div.sticky-header-container
    div.pt-3
      v-row.d-flex.align-center(no-gutters)
        v-col
          v-tabs(v-model="dataType" color="textColorAccent" :height="40")
            v-tab.button-AA-medium {{ $t('sales') }}
            v-tab.button-AA-medium.mx-n3 {{ $t('products') }}
            v-tab.button-AA-medium {{ $t('profit') }}
        v-col.shrink
          v-btn.my-auto.mr-2(color="primary400" text height=32 @click="filterSheet = true" x-small)
            eva-icon(name="options-2-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="12")
            .label.ml-n1.primary400--text {{ $t('filter') }}
  v-row.mt-2.mb-0.mt-4(no-gutters)
    v-col(cols="12" align="center")
      v-card(v-if="dataType == 2" flat)
        div.text-center.mt-4
          .s1.primary500--text {{ $t('profit_loss') }}
          .h5 
            span.danger500--text(v-if="totalProfitLoss < 0") {{ totalProfitLoss | displayPrice }}
            span.success500--text(v-else-if="totalProfitLoss > 0") {{ totalProfitLoss | displayPrice }}
            span(v-else) {{ totalProfitLoss | displayPrice }}
          .c2.textColorHint--text(v-if="selectedFilter.range.id !== 'custom'") {{ selectedFilter.range.name.toUpperCase() }}
          .c2.textColorHint--text(v-else) {{ customDateFilterRangeFormatted }}
        v-card.ma-4.pa-2(flat outlined max-width="480px" style="border: 1px solid var(--v-primary200);")
          v-row(no-gutters)
            v-col(align="center")
              .p2.my-1 {{ $t('income') }}
              .s1.mb-1 {{ incomesSummary.total | displayPrice }}
            v-divider.basic300(vertical)
            v-col(align="center")
              .p2.my-1 {{ $t('expense') }}
              .s1.mb-1 {{ expenseSummary.total | displayPrice }}
        .chart-top(style="height:189.5px; width:100%; position: relative; overflow: hidden;")
          apexchart(type="area" height="400", :options="chartOptions2", :series="dataSeries2")
        .chart-bottom(style="height:192px; position: relative; overflow: hidden;")
          apexchart(type="area" height="400", :options="chartOptions3", :series="dataSeries2" style="margin-top: -189.5px;")
      v-card(v-else flat)
        div.text-center.mt-4
          .s1.primary500--text {{ chartTitle }}
          .h5(v-if="metrics && chartName === 'sales'") {{ metrics[chartName].total | displayPrice }}
          .h5(v-else-if="metrics  && chartName !== 'sales'") {{ metrics[chartName].total | displayNumber }}
          .h6.primary500--text(v-else) -
          .c2.textColorHint--text(v-if="selectedFilter.range.id !== 'custom'") {{ selectedFilter.range.name.toUpperCase() }}
          .c2.textColorHint--text(v-else) {{ customDateFilterRangeFormatted }}
        apexchart(type="area" height="200", :options="chartOptions", :series="dataSeries")
  .modals
    filter-chart-sheet(v-if="filterSheet"
      :company="company"
      :filtered="selectedFilter"
      :open.sync="filterSheet"
      @filtered="handleFiltered")
</template>

<script>
import { mapActions, mapState } from 'vuex'
import FilterChartSheet from './FilterChartSheet'

export default {
  name: 'SalesAndProfitChart',
  components: { FilterChartSheet },
  props: ['company', 'stickyFilter', 'update'],
  data: (vm) => ({
    currentSpan: 'week',
    selectedFilter: {
      source: { name: 'All', id: '' },
      range: { name: vm.$t('this_week'), id: 'week' },
      selectedDateRange: []
    },
    customDateFilterMenu: false,
    customDateFilterRange: [],
    customDateFilterRangeFormatted: 'Date Range',
    filterSheet: false,
    filters: [
      {
        text: vm.$t('day'),
        value: 'day'
      },
      {
        text: vm.$t('week'),
        value: 'week'
      },
      {
        text: vm.$t('month'),
        value: 'month'
      },
      {
        text: vm.$t('year'),
        value: 'year'
      },
      {
        text: vm.$t('date_range'),
        value: 'custom'
      }
    ],
    dataType: 2,
    metrics: null,
    profitMetrics: null,
    incomesSummary: {
      total: 0
    },
    expenseSummary: {
      total: 0
    }
  }),
  computed: {
    ...mapState('user', ['member']),
    chartOptions () {
      const context = this
      return {
        colors: [this.$vuetify.theme.themes[this.$theme].basic600T40],
        chart: {
          fontFamily: 'Inter',
          height: '100%',
          toolbar: {
            show: false
          }
        },
        states: {
          active: {
            filter: {
              type: 'none'
            }
          }
        },
        grid: {
          show: true,
          strokeDashArray: 10,
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: false
        },
        fill: {
          type: 'solid'
        },
        yaxis: {
          labels: {
            formatter (value) {
              return isNaN(parseInt(value)) ? 100 : parseInt(value)
            }
          }
        },
        xaxis: {
          type: 'datetime',
          tooltip: {
            enabled: false
          },
          labels: {
            hideOverlappingLabels: true,
            datetimeUTC: false,
            datetimeFormatter: {
              year: 'yyyy',
              month: "MMM",
              day: 'dd/MM',
              hour: 'htt',
            }
          }
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          },
          y: {
            formatter (value) {
              if (context.chartName === 'sales') {
                return 'RM ' + context.$options.filters.displayNumber(value)
              }
              return value
            }
          }
        }
      }
    },
    chartTitle () {
      if (this.dataType === 0) {
        return 'Total Sales'
      } else  {
        return 'Products Sold'
      }
    },
    chartName () {
      if (this.dataType === 0) {
        return 'sales'
      } else  {
        return 'products'
      }
    },
    dataSeries () {
      let data = []
      const formatPoint = p => ({
        x: (new Date(p.point)).getTime(),
        y: this.chartName === 'sales' ? p.amount / this.$currency.multiplier : p.amount
      })
      if (this.metrics) {
       data = this.metrics[this.chartName].points.map(p => formatPoint(p))
      }
      return [{
        name: this.$options.filters.capitalize(this.chartName),
        type: 'column',
        data
      }]
    },
    pointDateFormat () {
      if (this.selectedFilter.range.id === 'day') {
        return 'ha'
      } else if (this.selectedFilter.range.id === 'week') {
        return 'dd/MM'
      } else if (this.selectedFilter.range.id === 'month') {
        return 'd'
      } else if (this.selectedFilter.range.id === 'year') {
        return 'MMM'
      } else if (this.selectedFilter.range.id === 'custom') {
        if (this.selectedFilter.selectedDateRange.length === 2 && this.selectedFilter.selectedDateRange[0] === this.selectedFilter.selectedDateRange[1]) {
          return 'ha'
        } else {
          return 'dd/MM'
        }
      } else {
        return ''
      }
    },
    currentPointName () {
      if (this.selectedFilter.range.id === 'day') {
        return 'This hour'
      } else if (this.selectedFilter.range.id === 'week') {
        return 'This day'
      } else if (this.selectedFilter.range.id === 'month') {
        return 'This date'
      } else if (this.selectedFilter.range.id === 'year') {
        return 'This month'
      } else if (this.selectedFilter.range.id === 'custom') {
        if (this.selectedFilter.selectedDateRange.length === 2 && this.selectedFilter.selectedDateRange[0] === this.selectedFilter.selectedDateRange[1]) {
          return 'This hour'
        } else {
          return 'This date'
        }
      } else {
        return ''
      }
    },
    // Profit
    totalProfitLoss () {
      if (!this.profitMetrics) {
        return 0
      }
      return this.profitMetrics['incomes'].total - this.profitMetrics['expenses'].total
    },
    chartOptions3 () {
      const context = this
      const options = {...this.chartOptions2}
      options.colors = [this.$vuetify.theme.themes[this.$theme].danger, this.$vuetify.theme.themes[this.$theme].info200T48, this.$vuetify.theme.themes[this.$theme].basic600T40]
      options.tooltip = {
        enabled: true,
        fixed: {
          enabled: true,
          position: 'bottomRight',
          offsetX: 0,
          offsetY: -35,
        },
        x: {
          format: 'dd/MM/yy HH:mm'
        },
        y: {
          formatter (value) {
            return 'RM ' + context.$options.filters.displayNumber(Math.abs(value))
          }
        }
      }
      return options
    },
    chartOptions2 () {
      const context = this
      const points = this.profitMetrics['incomes'].points
      let highestPoint = 0
      points.forEach(point => {
        const value = Math.abs(point.amount) / this.$currency.multiplier
        if (value > highestPoint) {
          highestPoint = value
        }
      })
      const pointsN = this.profitMetrics['expenses'].points
      pointsN.forEach(point => {
        const value = Math.abs(point.amount) / this.$currency.multiplier
        if (value > highestPoint) {
          highestPoint = value
        }
      })
      highestPoint = Math.ceil(highestPoint / this.$currency.multiplier) * 100
      return {
        colors: [this.$vuetify.theme.themes[this.$theme].primary, this.$vuetify.theme.themes[this.$theme].info200T48, this.$vuetify.theme.themes[this.$theme].basic600T40],
        chart: {
          type: 'line',
          fontFamily: 'Inter',
          height: 400,
          toolbar: {
            show: false
          },
          stacked: true,
          zoom: {
            enabled: false
          }
        },
        states: {
          active: {
            filter: {
              type: 'none'
            }
          }
        },
        yaxis: {
          min: -highestPoint - 100,
          max: highestPoint + 100,
          labels: {
            formatter (value) {
              return isNaN(parseInt(value)) ? 100 : parseInt(value)
            }
          }
        },
        xaxis: {
          type: 'datetime',
          tooltip: {
            enabled: false
          },
          labels: {
            hideOverlappingLabels: true,
            datetimeUTC: false,
            datetimeFormatter: {
              year: 'yyyy',
              month: "MMM",
              day: 'dd/MM',
              hour: 'htt',
            }
          }
        },
        hover: {
          filter: {
            type: 'none',
          }
        },
        markers: {
          size: 4,
          hover: {
            sizeOffset: 0
          },
          strokeWidth: 0,
        },
        tooltip: {
          enabled: true,
          fixed: {
            enabled: true,
            position: 'topRight',
            offsetX: 0,
            offsetY: 35,
          },
          x: {
            format: 'dd/MM/yy HH:mm'
          },
          y: {
            formatter (value) {
              return `${context.$currency.symbol} ` + context.$options.filters.displayNumber(Math.abs(value))
            }
          }
        },
        grid: {
          show: true,
          strokeDashArray: 10,
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight',
          width: [2, 0, 0]
        },
        fill: {
          type: 'solid'
        }
      }
    },
    dataSeries2 () {
      const formatPoint = p => ({
        x: (new Date(p.point)).getTime(),
        y: p.amount / this.$currency.multiplier
      })

      const formatPointN = p => ({
        x: (new Date(p.point)).getTime(),
        y: -p.amount / this.$currency.multiplier
      })

      let data = []
      if (this.profitMetrics) {
        data = this.profitMetrics['incomes'].points.map((val, idx) => {
          return  {
            point: val['point'],
            amount: val['amount'] - this.profitMetrics['expenses'].points[idx]['amount']
          }
        })
       data = data.map(p => formatPoint(p))
      }

      let dataP = []
      if (this.profitMetrics) {
       dataP = this.profitMetrics['incomes'].points.map(p => formatPoint(p))
      }

      let dataN = []
      if (this.profitMetrics) {
       dataN = this.profitMetrics['expenses'].points.map(p => formatPointN(p))
      }

      return [
        {
          name: 'Profit / Loss',
          type: 'line',
          data
        },
        {
          name: 'Income',
          type: 'column',
          data: dataP
        },
        {
          name: 'Expenses',
          type: 'column',
          data: dataN
        }
      ]
    }
  },
  watch: {
    company (val) {
      if (val) {
        this.fetchMetrics(this.currentSpan)
      }
    },
    update () {
      this.fetchMetrics(this.currentSpan)
    }
  },
  mounted () {
    this.fetchMetrics(this.currentSpan)
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    handleFiltered (data) {
      this.selectedFilter = data
      this.customDateFilterRangeFormatted = this.formatDateRange(data.selectedDateRange)
      this.fetchMetrics(data.range.id, data.selectedDateRange)
      this.$emit('spanChange', data)
    },
    formatDateRange (range) {
      if (range.length === 0) {
        return 'Date Range'
      } else if (range.length === 1) {
        const [year, month, day] = range[0].split('-')
        return `${day}/${month}/${year} -`
      } else {
        const [year1, month1, day1] = range[0].split('-')
        const [year2, month2, day2] = range[1].split('-')
        return `${day1}/${month1}/${year1} - ${day2}/${month2}/${year2}`
      }
    },
    fetchMetrics (span, range=null) {
      this.currentSpan = span
      let url = `/companies/${this.company.id}/charts/?span=${span}`
      let profitUrl = `/books/${this.company.slug}/profit_and_loss/charts/?span=${span}`
      let urlIncome = `/books/${this.company.slug}/incomes/summary/?span=${span}`
      let urlExpense = `/books/${this.company.slug}/expenses/summary/?span=${span}`
      if (span === 'custom') {
        url = `/companies/${this.company.id}/charts/?span=custom&from=${range[0]}&until=${range[1]}`
        profitUrl = `/books/${this.company.slug}/profit_and_loss/charts/?span=custom&from=${range[0]}&until=${range[1]}`
        urlIncome = `/books/${this.company.slug}/incomes/summary/?span=custom&from=${range[0]}&until=${range[1]}`
        urlExpense = `/books/${this.company.slug}/expenses/summary/?span=custom&from=${range[0]}&until=${range[1]}`
      }
      this.$axios.get(url)
        .then(resp => {
          this.metrics = resp.data
        })
        .catch(e => {
          this.showMessage(['error', e.response.data[0]])
        })
      this.$axios.get(profitUrl)
        .then(resp => {
          this.profitMetrics = resp.data
        })
        .catch(e => {
          this.showMessage(['error', e.response.data.detail])
        })
      this.$axios.get(urlIncome)
        .then(resp => {
          this.incomesSummary = resp.data
        }).catch(() => {})
      this.$axios.get(urlExpense)
        .then(resp => {
          this.expenseSummary = resp.data
        }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>

.sticky-header-container {
  position: relative;
  background-color: var(--v-basic100);
  height: 52px;
}
.sticky-header {
  position: fixed;
  transition: 0.3s all ease-out;
  transform: translate3d(0, 0, 0) !important;
  z-index: 3;
  width: 100%;
  max-width: 600px;
  background-color: var(--v-basic100);
}
.sticky-header.hidden-header{
  transform: translate3d(0, -100%, 0) !important;
}

</style>